import { render, staticRenderFns } from "./P102.vue?vue&type=template&id=9b70c36e&scoped=true"
import script from "./P102.vue?vue&type=script&lang=js"
export * from "./P102.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/Pdis.css?vue&type=style&index=0&id=9b70c36e&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b70c36e",
  null
  
)

export default component.exports